import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
  lowerTitle: { color: theme.palette.grey[600] },
}));

export default useStyles;
